import React from 'react';

// table context for sharing with rendered cells
export const TableContext = React.createContext({});
export const withTableContext = Component => props => (
  <TableContext.Consumer>
    {value => <Component tableContext={value} {...props} />}
  </TableContext.Consumer>
);
